import http from 'hub-http/clients/apiClient';
export const submitCTAClick = correlationId => http.put(`personalization/v1/recommendation/ml/cta-click/${correlationId}`);